import {AssistantEvenCompactModel} from "./assistants";
import {ListModel} from "./common";

export enum PhoneNumberAssignmentOptionModel {
  TWILIO = "twilio",
  BUY = "buy",
}

export enum PhoneNumberTypeModel {
  ACTIVE_NUMBERS = "activeNumbers",
  ADDRESSES = "addresses",
  VERIFIED_CALLER_IDS = "verifiedCallerIds",
}

export type ActiveNumberRecordModel = {
  id: string;
  number: string;
  type: "Active" | "Disabled";
  calls: boolean;
  sms: boolean;
  provider?: string;
  assistants?: AssistantEvenCompactModel[];
};

export type ActiveNumberListModel = ListModel<ActiveNumberRecordModel>;

export type AddressesRecordModel = {
  id: string;
  address: string;
  customer: string;
  country: "United States" | "Australia" | "Canada";
  validated: boolean;
};

export type AddressesListModel = ListModel<AddressesRecordModel>;

export type VerifiedCallerIdsRecordModel = {
  id: string;
  phoneNumber: string;
  name: string;
  validated: boolean;
  assistants?: AssistantEvenCompactModel[];
};

export type VerifiedCallerIdsListModel =
  ListModel<VerifiedCallerIdsRecordModel>;

export enum PhoneNumberRegionModel {
  UNITED_STATES = "united-states",
  AUSTRALIA = "australia",
  CANADA = "canada",
}
